var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gallery-message" }, [
    _c(
      "div",
      { ref: "cardContainer", staticClass: "cards" },
      [
        _vm.currentIndex !== 0
          ? _c(
              "div",
              { staticClass: "prev", on: { click: _vm.prevCard } },
              [
                _c(
                  "md-button",
                  { staticClass: "md-icon-button" },
                  [_c("md-icon", [_vm._v("chevron_left")])],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.cards, function (card, index) {
          return _c("GalleryImageCard", {
            key: "card-" + index,
            ref: "cardRefs",
            refInFor: true,
            attrs: {
              card: card,
              "on-card-updated": function (payload) {
                return _vm.onCardUpdated(index, payload)
              },
              "show-add-card": index === _vm.cards.length - 1,
              "on-add-card": _vm.onAddCard,
              current: index === _vm.currentIndex,
              "remove-card-enabled": _vm.cards.length > 1,
              "remove-card": function () {
                return _vm.removeCardWithIndex(index)
              },
              "flatted-diagram": _vm.flattedDiagram,
              "preview-mode": _vm.previewMode,
              "show-attributes": _vm.showAttributes,
              "show-emoji": _vm.showEmoji,
              "show-emoji-picker": _vm.showEmojiPicker,
            },
          })
        }),
        _vm._v(" "),
        !_vm.previewMode
          ? _c(
              "div",
              { staticClass: "next" },
              [
                _vm.currentIndex !== _vm.cards.length - 1
                  ? _c(
                      "md-button",
                      {
                        staticClass: "md-icon-button",
                        on: { click: _vm.nextCard },
                      },
                      [_c("md-icon", [_vm._v("chevron_right")])],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }